import { useQuery } from "react-query";
import axios from "axios";

const useProductReviews = (productId) =>
  useQuery(
    ["productReviews", productId],
    async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/product/products/${productId}/reviews`
      );
      return res.data;
    },
    { enabled: !!productId }
  );

export default useProductReviews;
